import { Star } from "lucide-react";
import { memo } from "react";

interface Testimonial {
  name: string;
  role: string;
  avatar: string;
  rating: number;
  quote: string;
}

const testimonials: Testimonial[] = [
  {
    name: "Ana Paula",
    role: "Loja Moda Feminina",
    avatar: "👩‍💼",
    rating: 5,
    quote: "Minhas vendas aumentaram 35% no primeiro mês. As clientes adoram ver como as roupas ficam!"
  },
  {
    name: "Carla Mendes",
    role: "Boutique Online",
    avatar: "👩‍🦰",
    rating: 5,
    quote: "Economizo horas que gastava com modelos e fotógrafos. Agora gero tudo em minutos."
  },
  {
    name: "Fernanda Costa",
    role: "Moda Plus Size",
    avatar: "👩‍🦱",
    rating: 5,
    quote: "Finalmente consigo mostrar roupas plus size em modelos reais. Minhas clientes se identificam!"
  }
];

const TestimonialCard = memo(function TestimonialCard({ testimonial }: { testimonial: Testimonial }) {
  return (
    <div className="relative bg-card rounded-2xl border border-border pt-8 pb-6 px-6 hover:border-primary/50 transition-all duration-300 hover:scale-[1.02] hover:shadow-glow">
      {/* Rating */}
      <div className="flex gap-1 mb-4">
        {Array.from({ length: testimonial.rating }).map((_, i) => (
          <Star key={i} className="w-5 h-5 fill-primary text-primary" />
        ))}
      </div>

      {/* Quote */}
      <p className="text-foreground mb-6 leading-relaxed">
        "{testimonial.quote}"
      </p>

      {/* Author */}
      <div className="flex items-center gap-3">
        <div className="w-12 h-12 rounded-full bg-accent flex items-center justify-center text-2xl">
          {testimonial.avatar}
        </div>
        <div>
          <p className="font-semibold">{testimonial.name}</p>
          <p className="text-sm text-muted-foreground">{testimonial.role}</p>
        </div>
      </div>
    </div>
  );
});

export const TestimonialsSection = memo(function TestimonialsSection() {
  return (
    <section className="py-24 bg-card/50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            O que dizem nossas <span className="text-gradient">lojistas</span>
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Histórias reais de quem já transformou sua loja
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <TestimonialCard key={index} testimonial={testimonial} />
          ))}
        </div>
      </div>
    </section>
  );
});
